'use strict';

$('.search-course').on('submit', function (e) {
	var $form = $(this)
	var $selects = $form.find('select');
	var value = '';

	$selects.forEach(function () {
		if ( this.value ) {
			value = this.value;
		}
	});

	if ( value === '' ) {
		e.preventDefault();
	}
});